if (!customElements.get('custom-free-shipping-bar')) {
    class CustomFreeShippingBar extends HTMLElement {
        constructor() {
            super();
            this.minThreshold = null;
            this.messages = null;
            this.backgroundColor = null;
            this.taxRules = [];
        }

        connectedCallback() {
            this.init();
        }

        async init() {
            this.minThreshold = Number(this.getAttribute('data-min-threshold'));
            this.messages = this.getAttribute('data-messages');
            if (this.messages && typeof this.messages === 'string') {
                this.messages = this.messages.split('___');
            }
            this.backgroundColor = this.getAttribute('data-background-color');

            this.taxRules = await window.CustomTaxRules.getTaxRules(this.getAttribute('data-country-code'));
            this.updateBar();
        }

        updateBar() {
            const itemsData = this.getAttribute('data-cart-items');
            const cartTotal = window.CustomUtilities.calculateCartTotal(itemsData, this.taxRules, this.getAttribute('data-tax-exempt'));

            const thresholdValue = this.minThreshold;
            const remaining = thresholdValue - cartTotal;
            let progress = (cartTotal / thresholdValue) * 100;
            if (progress > 100) progress = 100;

            const moneyTillFreeShipping = window.CustomNumberFormatters.formatPrice(remaining);
            const countryName = this.getAttribute('data-country-name').toUpperCase();

            const standardMessage = this.messages[0].replace('[amount]', moneyTillFreeShipping).replace('[country]', countryName);
            const closeMessage = this.messages[1].replace('[amount]', moneyTillFreeShipping).replace('[country]', countryName);
            const freeMessage = this.messages[2].replace('[country]', countryName);

            const htmlContent = `
                <div class="caption">
                    ${progress < 60 ? standardMessage : progress < 100 ? closeMessage : freeMessage}
                </div>
                <div
                    class="free-shipping-bar"
                    style="--shipping-bar-width: ${progress}%; --shipping-bar-background: ${this.backgroundColor};"
                ></div>
            `;
            this.innerHTML = htmlContent;
        }
    }

    customElements.define('custom-free-shipping-bar', CustomFreeShippingBar);
}
